import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DfImageDirective } from '@df/module-image/df-image.directive';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { PageViewAbstract } from './page-view.abstract';

@Component({
    selector: 'page',
    templateUrl: './page.component.html',
    standalone: true,
    imports: [DfImageDirective, RouterModule, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageComponent extends PageViewAbstract {}
